import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Paper,
  Snackbar,
  TextField,
  Fab,
  DialogTitle,
  DialogContentText,
  DialogContent,
  DialogActions,
  Dialog
} from '@material-ui/core';
import {
  Add,
  Edit,
  Delete
} from '@material-ui/icons';
import PerfectScrollbar from 'react-perfect-scrollbar';

const SERVER_ADDRESS = process.env.REACT_APP_SERVER_ADDRESS;

class Apropos extends React.Component {
  constructor() {
    super();
    this.state = {
      apropos: [],
      lieux: "",
      nom: "",
      fonction: "",
      isLogged: true,
      redirect: false,
      newModalOpen: false,
      deleteModalOpen: false,
      deleteId: "",
      modifedId: "",
      snackbarMessage: "",
      snackbarOpen: false,
      sidebarOpen: false,
      putModalOpen: false,
      redirectLogOut: false,
      limit: false
    }
  }

  handleChangeInput = (event) => {
    switch (event.target.name) {
      case 'lieux':
        this.setState({ lieux: event.target.value })
        break;
      case 'nom':
        this.setState({ nom: event.target.value })
        break;
      case 'fonction':
        this.setState({ fonction: event.target.value })
        break;
      default:
        break;
    }
  }

  deleteBureau = () => {
    this.handleCloseDeleteModal();
    const apropos_id = this.state.apropos[this.state.deleteId].id
    fetch(SERVER_ADDRESS + '/apropos/' + apropos_id,
      {
        method: 'DELETE',
        headers: new Headers({
          'authorization': 'Bearer ' + localStorage.getItem('token')
        })
      }
    )
      .then(() => { this.getData() })
      .then(
        (res) => {
          this.setState({
            snackbarOpen: true,
            snackbarMessage: "Apropos supprimé"
          })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  addBureau = () => {
    this.handleCloseNewModal();
    let apropos = {
      lieux: this.state.lieux,
      nom: this.state.nom,
      fonction: this.state.fonction
    }
    fetch(SERVER_ADDRESS + '/apropos',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(apropos),
      })
      .then(res => {
        res.json()
        console.log(res)
      })
      .then(() => { this.getData() })
      .then(res => this.setState({ snackbarMessage: "Apropos ajouté." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
  }

  putBureau = () => {
    this.handleClosePutModal();
    let apropos = {
      lieux: this.state.lieux,
      nom: this.state.nom,
      fonction: this.state.fonction
    }
    let apropos_id = this.state.apropos[this.state.modifedId].id
    console.log(apropos_id)
    fetch(SERVER_ADDRESS + '/apropos/' + apropos_id,
      {
        method: 'PUT',
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),
        body: JSON.stringify(apropos),
      })
      .then(
        () => {
          fetch(SERVER_ADDRESS + '/apropos',
            {
              headers: new Headers({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + localStorage.getItem('token')
              }),

            }
          )
            .then(res => res.json())
            .then(res => this.setState({ apropos: res }))
            .then(
              () => console.log(this.state.apropos)
            )
        }
      )
      .then(res => this.setState({ snackbarMessage: "Apropos modifié." }))
      .then(
        (res) => {
          this.setState({ snackbarOpen: true })
          setTimeout(() => {
            this.setState({ snackbarOpen: false })
          }, 3000);
        }
      )
      .then(
        () => {
          const newArrayBureau = this.state.apropos
          newArrayBureau[this.state.modifedId] = {
            id: apropos_id,
            email: this.state.email
          }
          this.setState({ apropos: newArrayBureau })
        }
      )
  }

  handleClosePutModal = () => {
    this.setState({ putModalOpen: false })
  }

  handleOpenPutModal = (index) => {
    let user_id = this.state.apropos[index].id
    fetch(SERVER_ADDRESS + '/apropos/' + user_id)
      .then(res => res.json())
      .then(res => {
        this.setState({
          lieux: res[0].lieux,
          nom: res[0].nom,
          fonction: res[0].fonction
        }, () => {
          this.setState({ putModalOpen: true })
          this.setState({ modifedId: index })
        })
      })
  }

  handleCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false })
  }

  handleOpenDeleteModal = (index) => {
    this.setState({ deleteModalOpen: true })
    this.setState({ deleteId: index })
  }

  handleOpenNewModal = () => {
    this.setState({
      lieux: "",
      nom: "",
      fonction: ""
    }, () => {
      this.setState({ newModalOpen: true })
    })
  }

  handleCloseNewModal = () => {
    this.setState({ newModalOpen: false })
  }

  openMenu = () => {
    this.setState({ sidebarOpen: !this.state.sidebarOpen })
    const menu = document.querySelector('.side-nav')
    if (this.state.sidebarOpen === false) {
      menu.style.display = "block"
    }
    else {
      menu.style.display = "none"
    }
  }

  getData = () => {
    fetch(SERVER_ADDRESS + '/apropos',
      {
        headers: new Headers({
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + localStorage.getItem('token')
        }),

      }
    )
      .then(res => res.json())
      .then((res) => {
        this.setState({ apropos: res })
      })

  }

  componentDidMount() {
    const token = {
      token: localStorage.getItem('token')
    }

    fetch(SERVER_ADDRESS + '/token',
      {
        method: 'POST',
        headers: new Headers({
          'Content-Type': 'application/json'
        }),
        body: JSON.stringify(token),
      })
      .then(res => res.json())
      .then(
        (res) => {
          this.setState(
            {
              isLogged: res.succes,
              redirect: res.succes ? false : true
            });
        }
      )
    this.getData()
  }

  logOut = () => {
    this.setState({ redirectLogOut: true })
    localStorage.setItem('token', "")
  }

  render() {
    return (
      <>
        <Grid className="item" item>
          <Paper elevation={1}>
            <Card>
              <CardHeader
                className="jtestd"
                action={
                  <Fab
                    style={{ backgroundColor: "#1976d2", color: 'white' }}
                    onClick={this.handleOpenNewModal}
                    size="small"
                  >
                    <Add />
                  </Fab>
                }
                title="A propos"
              />
              <Divider />
              <CardContent className="content">
                <PerfectScrollbar>
                  <div className="inner">
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>Lieux</TableCell>
                          <TableCell>Nom</TableCell>
                          <TableCell>Fonction</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.apropos.map((apropos, index) => (
                          <TableRow
                            hover
                            key={apropos.id}
                          >
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{apropos.lieux}</TableCell>
                            <TableCell>{apropos.nom}</TableCell>
                            <TableCell>{apropos.fonction}</TableCell>
                            <TableCell>

                              <Button
                                style={{ backgroundColor: "#1976d2", color: 'white' }}
                                onClick={() => this.handleOpenPutModal(index)}
                                size="small"
                                startIcon={<Edit />}
                              >
                                Editer
                          </Button>

                              <Button
                                style={{ marginLeft: '10px' }}
                                disabled={this.state.limit}
                                variant="contained"
                                onClick={() => this.handleOpenDeleteModal(index)}
                                color="secondary"
                                size="small"
                                endIcon={<Delete />}
                              >
                                Supprimer
                          </Button>

                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </PerfectScrollbar>
              </CardContent>
            </Card>
          </Paper>
        </Grid>



        <Dialog open={this.state.newModalOpen} onClose={this.handleCloseNewModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Crée un à propos</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour crée un apropos veuillez remplir les champs obligatoire.
                  </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="lieux"
              label="Lieux"
              type="text"
              fullWidth
              name="lieux"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="nom"
              label="Nom"
              type="text"
              fullWidth
              name="nom"
              onChange={this.handleChangeInput}
            />
            <TextField
              margin="dense"
              id="fonction"
              label="fonction"
              type="text"
              fullWidth
              name="fonction"
              onChange={this.handleChangeInput}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseNewModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.addBureau} color="primary">
              Créer
                  </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteModalOpen}
          onClose={this.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Suppression d'un à propos"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Etes vous sur de vouloir supprimer l'à propos' ?
              </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleCloseDeleteModal} color="primary">
              Non
              </Button>
            <Button onClick={this.deleteBureau} color="primary" autoFocus>
              Oui
              </Button>
          </DialogActions>
        </Dialog>

        <Dialog open={this.state.putModalOpen} onClose={this.handleClosePutModal} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Modifier un apropos</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Pour modifer cet apropos veuillez saisir les champs obligatoire.
                </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="lieux"
              label="Lieux"
              type="text"
              fullWidth
              name="lieux"
              onChange={this.handleChangeInput}
              defaultValue={this.state.lieux}
            />
            <TextField
              margin="dense"
              id="nom"
              label="Nom"
              type="text"
              fullWidth
              name="nom"
              onChange={this.handleChangeInput}
              defaultValue={this.state.nom}
            />
            <TextField
              margin="dense"
              id="fonction"
              label="fonction"
              type="text"
              fullWidth
              name="fonction"
              onChange={this.handleChangeInput}
              defaultValue={this.state.fonction}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClosePutModal} color="primary">
              Annuler
                  </Button>
            <Button onClick={this.putBureau} color="primary">
              Modifier
                  </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          open={this.state.snackbarOpen}
          message={this.state.snackbarMessage}
        />

      </>
    );
  }
}

export default Apropos;
